<template>
  <div>

     <div id="adabundle-online-dictionary-box" v-show="widgetOptions.onlineDictionary == 1">
        <form id="adabundle-online-dictionary-form" enctype="multipart/form-data" action="#" method="POST">
                <!-- placeholder="Search Wikipedia Dictionary" -->
            <input
                type="text"
                tabindex="0"
                id="adabundle-online-dictionary-search"
                name="adabundle-online-dictionary-search"
                autocomplete="off"
                :placeholder="t.search_wikipedia_dictionary.text"
                aria-label="Search Wikipedia Dictionary"
            />
        </form>
        <button role="button" tabindex="0" aria-label="Clear search results" id="adabundle-online-dictionary-search-close"></button>
        <div id="adabundle-online-dictionary-search-results-box">
            <ul id="adabundle-online-dictionary-search-results"></ul>
        </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utility from '../common/Utility';
import  HTTP from "../common/Http";

export default {
  name: "OnlineDictionary",
  components: {
  },
  created () {
    this.init()
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setWidgetOptions') {
        this.widgetOptions = state.widgetOptions;
        this.init()
      }
    });
  },
  mounted(){
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState([
      "timeStamp",
      "wid",
      "widgetOptions",
      "debug",
      "t",
    ])
  },
  methods: {
    init(){
        
     }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
